import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 从环境变量获取基础URL
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 业务成功
    if (res.code === 200 || res.success) {
      return res
    }
    if (res.code === 401) {
        // 清除本地存储的认证信息
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('user')
        
        // 跳转到登录页
        const loginPath = '/login'
        //window.location.href = loginPath;
        
        const currentPath = window.location.pathname
        
        // 如果当前不是登录页，跳转到登录页并携带返回地址
        if (currentPath !== loginPath) {
          const returnUrl = encodeURIComponent(currentPath + window.location.search)
          window.location.href = `${loginPath}?redirect=${returnUrl}`
        }
    }
    console.error('业务失败:', res)
    
    // 业务失败 - 显示错误消息并reject
    const errorMessage = res.msg || res.message || '请求失败'
    Message.error(errorMessage)
    return Promise.reject(new Error(errorMessage))
  },
  error => {
    // HTTP错误（如500、404等）
    //let errorMessage = '请求失败'
    
    if (error.response) {
      console.error("发生错误",error)
      // 服务器返回了错误状态码
      const data = error.response.data
      return Promise.reject(data)

    } 
    // 检查是否是 CORS 错误
    if (!error.response) {
      console.error('请求失败，可能是CORS问题:', error)
      Message.error('网络请求失败，请检查网络连接或CORS配置')
      return Promise.reject('网络请求失败，请检查网络连接或CORS配置')
    }

    // 处理 401 错误
    if (error.response.status === 401) {
      // 你的原有 401 处理逻辑
      //const refreshToken = localStorage.getItem('refreshToken')
      // ...
      const data = error.response.data
      return Promise.reject(data)
    }

    // 其他错误处理
    let errorMessage = '请求失败'
    if (error.response.data) {
      errorMessage = error.response.data.msg || error.response.data.message || errorMessage
    }
    
    Message.error(errorMessage)
    return Promise.reject(error)
    // else if (error.request) {
    //   // 请求发送了但没有收到响应
    // } 
    // else {
    // }
  }
)

export default service